'use client'
import { Kanit } from 'next/font/google';
import Script from 'next/script';
import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google';
import './globals.css';
import '../public/assets/css/all.min.css';
import '../public/assets/css/bootstrap.min.css';
import '../public/assets/css/swiper-bundle.min.css';
import '../public/assets/css/progressbar.css';
import '../public/assets/css/meanmenu.min.css';
import '../public/assets/css/master.css';

import Header2 from '@/components/Header/Header2';
import Cursor from '@/components/Header/Cursor';
import Footer3 from '@/components/Footer/Footer3';
import { usePathname } from 'next/navigation';
import SEO from './api/seo/SEO';

const kanit = Kanit({
  subsets: ['latin'],
  weight: '400'
});

// async
export default function RootLayout({
  children,
  params,
}: {
  children: React.ReactNode;
  params: { slug: string };
}) {

  const pathname = usePathname();

  return (
    <html lang="en">
      <head>
        {/* <link rel="icon" href="/assets/jbcodeapp_favicon.png" /> */}

        {/* Dynamic SEO */}
        <SEO FullURL={pathname} />

        {/* Google analytics */}
        <GoogleTagManager gtmId='GTM-TVG69Z77' />

        <GoogleAnalytics gaId='G-TY57RQHMFC' />

        {/* AHREF analytics */}
        <script src="https://analytics.ahrefs.com/analytics.js" data-key="7tzDuqmuuCS47d6XWBK6Kw" async></script>

        {/* jbcodeapp campaign */}
        <script id="ACXConnectScript" type="text/javascript" src="https://campaigns.getbiz.solutions/websites/67dd093ddea9e/connect.js" async></script>
    
      </head>

      <body className={`${kanit.className}`}
        style={{
          // fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace',
          letterSpacing: '0.1rem',
        }}

      >
        <Cursor />
        <Header2 />
        <div id="smooth-wrapper mt-[5%]">
          <div id="smooth-content">
            {children}
            <Footer3 />
          </div>
        </div>
      </body>

      {/* Order-dependent stack. main.js uses $(document).ready and the
          plugins (meanmenu etc.) need `jQuery` defined first. Keep the stack
          on the default `afterInteractive` strategy, which preserves load
          order and is already deferred past first paint. Do NOT move these to
          `lazyOnload` — that loads them async out of order and breaks the
          jQuery -> plugin dependency (ReferenceError: jQuery is not defined).
          Only meanmenu stays lazyOnload (it loads after jQuery is ready). */}
      <Script src="/assets/js/jquery-3.6.0.min.js" />
      <Script src="/assets/js/bootstrap.bundle.min.js" />
      <Script src="/assets/js/swiper-bundle.min.js" />
      <Script src="/assets/js/counter.js" />
      <Script src="/assets/js/gsap.min.js" />
      <Script src="/assets/js/ScrollTrigger.min.js" />
      <Script src="/assets/js/ScrollToPlugin.min.js" />
      <Script src="/assets/js/ScrollSmoother.min.js" />
      <Script src="/assets/js/SplitText.min.js" />
      <Script src="/assets/js/chroma.min.js" />
      <Script src="/assets/js/mixitup.min.js" />
      <Script src="/assets/js/vanilla-tilt.js" />
      <Script src="/assets/js/jquery.meanmenu.min.js" strategy="lazyOnload" />
      <Script src="/assets/js/main.js" />

    </html>
  );
}
